export const SET_TOTAL_ACTIVE_USERS = "setTotalActiveUsers";
export const SET_TOTAL_ACTIVITY_PER_AGE = "setTotalActivityPerAge";
export const SET_ACTIVITY_RESULTS = "setActivityResults";
export const SET_SKILLGAMES_SINGLE_USAGE = "setSkillgamesSingleUsage";
export const SET_SKILLGAMES_MULTI_USAGE = "setSkillgamesMultiUsage";
export const SET_SKILLGAMES_PERCENTAGE_USAGE = "setSkillgamesPercentageUsage";
export const SET_USER_COURTS = "setUserCourts";
export const SET_USER_OVERVIEW = "setUsersOverview";

//Home page
export const SET_ACTIVITY_PER_CATEGORY = "setActivityPerCategory";
export const SET_BOOKINGS_PER_CATEGORY = "setBookingsPerCategory";
export const SET_BOOKINGS_PER_FIELD = "setBookingsPerField";
export const SET_MOST_POPULAR_OVERVIEW = "setMostPopularOverview";
export const SET_BOOKINGS_OVERVIEW = "setBookingsOverview";
// SKILLCOURT SECTION

export const SET_SELECTED_COURT = "setSelectedCourt";
export const SET_FIELDS = "setFields";
export const SET_FIELDS_OVERVIEW = "setFieldsOverview";
